module.exports = __webpack_public_path__ + "src/assets/img/progroup-2.447e0d13.png";